import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import counterpart from 'counterpart';

import Button from 'Components/Button';
import SmallButton from 'Components/Button/SmallButton';
import SelectInput from 'Components/forms/select-input';
import { OptionBoxPopupFooter } from 'Components/OptionBoxPopup';
import icon_wait from 'Assets/img/icon-WaitW.svg';
import LinkInlineButton from 'Components/Button/LinkInlineButton';
import Checkbox from '../forms/checkbox/Checkbox';
import './FileExport.scss';
import icon_full_pan from 'Assets/img/icon-full-pan.svg';

const format = require('string-template');

export class FileExport extends Component {

  constructor(props) {
    super(props);

    const currentDateTime = new Date().toISOString();
    const exportedFileName = props.suggestedFileName
      ? `${props.suggestedFileName}_${currentDateTime}`
      : `${props.translations.export}_${currentDateTime}`;

    this.state = {
      fileName: exportedFileName,
      parsedSavedFilters: parseReportSavedFilters(this.props.savedFilters),
      selectedExportType: this.props.selectedExportType || {},
      selectedFileType: this.props.fileTypes[0],
      warning: '',
      selectedItem: this.props.selectSavedFilters,
      hugeExportMsg: this.props.hugeExportMsg,
      isFullPanExport: false,
      acquirerCode:JSON.parse(sessionStorage.getItem("state")).auth.user.acquirerCode,
    };

    this.errors = {
      general: counterpart('globalTranslate.errors.reportsGeneral'),
      pdf: counterpart('globalTranslate.errors.reportsPDF'),
    };
    this.attachBindings();
  }
  attachBindings() {
    this.includePanOnChange = this.includePanOnChange.bind(this);
  }
  componentDidMount() {
    if (this.props.exportSavedFilter && this.props.getReportUserFilters) {
      this.getReportInfo(this.props.reportId);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.exportSavedFilter) {
      this.setState({
        selectedExportType: {
          value: 'all-columns',
          text: 'All Columns',
        },
      });
    }

    if (
      nextProps.savedFilters &&
      this.props.savedFilters &&
      nextProps.savedFilters.length !== this.props.savedFilters.length
    ) {
      this.setState({
        parsedSavedFilters: parseReportSavedFilters(nextProps.savedFilters),
      });
    }
  }

  onFileNameChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  onSelectionChange = (option) => {
    const selectedItem = this.state.parsedSavedFilters.find(
      (item) => item.value === option,
    );

    if (selectedItem) {
      this.setState({ selectedItem });
    }
  };

  getReportInfo = (reportId) => {
    this.props.getReportUserFilters(reportId);
  };

  get exportTypes() {
    return this.props.exportTypes.map((exportOption) => {
      if (this.state.selectedFileType.value !== 'pdf') {
        const fileClass = classnames('file-export-row-item '+this.state.acquirerCode, {
          selected:
            this.state.selectedExportType &&
            this.state.selectedExportType.value === exportOption.value,
        });

        const buttonClass = classnames('file-export-button -'+this.state.acquirerCode, {
          selected:
            this.state.selectedExportType &&
            this.state.selectedExportType.value === exportOption.value,
        });

        return (
          <li key={exportOption.value} className={fileClass}>
            <button
              id={`${this.props.suggestedFileName}_export_btn_${
                exportOption.text
                }`}
              name="selectedExportType"
              onClick={(event) => this.selectOption(event, exportOption)}
              className={this.props.isMaxExportLimit ? 'file-export-button-disabled' : buttonClass}
              disabled={this.props.isMaxExportLimit}
            >
              {exportOption.text}
            </button>
          </li>
        );
      } else if (this.state.selectedFileType.value === 'pdf' && exportOption.value !== 'all-columns') {
        const fileClass = classnames('file-export-row-item '+this.state.acquirerCode, {
          selected:
            this.props.visibleColumns &&
            this.props.visibleColumns.length < 11,
          error: this.props.visibleColumns &&
            this.props.visibleColumns.length > 10,
        });

        const buttonClass = classnames('file-export-button -'+this.state.acquirerCode, {
          selected:
            this.props.visibleColumns &&
            this.props.visibleColumns.length < 11,
          error: this.props.visibleColumns &&
            this.props.visibleColumns.length > 10,
        });


        return (
          <li key={exportOption.value} className={fileClass}>
            <button
              id={`${this.props.suggestedFileName}_export_btn_${
                exportOption.text
                }`}
              name="selectedExportType"
              className={buttonClass}
            >
              {`${exportOption.text} ${this.props.translations.maxOfTen}`}
            </button>
          </li>
        );
      }
    });
  }

  cancelAction = () => {
    this.setState({
      fileName: '',
      selectedExportType: {},
      selectedFileType: {},
      warning: '',
    });
    this.props.cancelAction();
  };

  exportAction = () => {
    const {
      fileName,
      selectedExportType,
      selectedFileType,
      selectedItem,
      hugeExportMsg,
      isFullPanExport,
    } = this.state;
    const { reportId } = this.props;
    const updatedFilters = selectedItem.filterJson
      ? cleanSavedFilters(selectedItem.filterJson)
      : [];
    this.props.exportAction(
      fileName,
      selectedExportType,
      selectedFileType,
      reportId,
      updatedFilters,
      hugeExportMsg,
      isFullPanExport,
    );

    this.setState({
      fileName: '',
      selectedExportType: {},
      selectedFileType: this.props.fileTypes[0],
      warning: '',
    });
  };

  get fileTypes() {
    return this.props.fileTypes.map((file) => {
      const fileClass = classnames('file-export-row-item '+this.state.acquirerCode, {
        selected:
          this.state.selectedFileType &&
          this.state.selectedFileType.value === file.value,
      });
      const buttonClass = classnames('file-export-button -'+this.state.acquirerCode, {
        selected:
          this.state.selectedFileType &&
          this.state.selectedFileType.value === file.value,
      });

      return (
        <li key={file.value} className={fileClass}>
          <button
            id={`${this.props.suggestedFileName}_export_btn_${file.text}`}
            name="selectedFileType"
            onClick={(event) => this.selectOption(event, file)}
            className={this.props.isMaxExportLimit ? 'file-export-button-disabled' : buttonClass}
            disabled={this.props.isMaxExportLimit}
          >
            {file.text}
          </button>
        </li>
      );
    });
  }

  includePanOnChange() {
    this.setState({
      isFullPanExport: !this.state.isFullPanExport,
    });
  }
  selectOption = (event, option) => {
    const stateKey = event.target.name;
    this.setState({
      [stateKey]: option,
      warning: '',
    });

    if (option.value === 'pdf') {
      this.setState({ isFullPanExport: false });
      if (this.props.visibleColumns.length > 10) {
        this.setState({
          warning: format(this.props.translations.pdfExceedColumnError,
            {
              count: this.props.visibleColumns.length,
            }),
        },
        );
      }
    }
  };

  render() {
    let disabledButton = this.state.selectedFileType.value === 'csv' && this.state.selectedExportType.value ?
      this.state.warning || this.state.fileName.length < 1
      : !this.state.selectedFileType.value ||
      !this.state.selectedExportType.value ||
      this.state.fileName.length < 1;

    if (this.props.isMaxExportLimit) { disabledButton = this.props.isMaxExportLimit; }

    const fileClass = classnames('file-export-row-item '+this.state.acquirerCode, {
      selected: true,
      error: true,
    });

    const buttonClass = classnames('file-export-button -'+this.state.acquirerCode, {
      selected: true,
      error: true,
    });

    const { translations, exportSavedFilter, viewReport } = this.props;

    const { parsedSavedFilters, selectedItem } = this.state;

    const fileExportContainer = classnames('file-export', {
      'no-saved-filters': parsedSavedFilters.length === 0,
    });

    return (
      <div className={fileExportContainer}>
        {exportSavedFilter ? (
          <div>
            <span className={"file-export-header -"+this.state.acquirerCode}>{translations.header}</span>
            {parsedSavedFilters.length !== 0 ? (
              <div className="file-export-content">
                <ul className="file-export-row export-types">
                  <li className={"file-export-row-title-"+this.state.acquirerCode}>
                    {exportSavedFilter
                      ? 'Select a Saved Filter'
                      : translations.exportTypesTitle}
                  </li>
                  {exportSavedFilter ? (
                    <li className="file-export-row-items">
                      <SelectInput
                        dataList={parsedSavedFilters}
                        wrapperClass="select-menu__form reports"
                        handleSelection={this.onSelectionChange}
                        selectedItem={selectedItem}
                        extraClass="select-saved-filter"
                      />
                    </li>
                  ) : (
                      <li>
                        <ul className="file-export-row-items">
                          {this.exportTypes}
                        </ul>
                      </li>
                    )}
                </ul>
                <ul className="file-export-row file-types">
                  <li className={"file-export-row-title-"+this.state.acquirerCode}>
                    {translations.fileTypesTitle}:
                  </li>
                  <li>
                    <ul className="file-export-row-items">{this.fileTypes}</ul>
                  </li>
                </ul>
                <ul className="file-export-row">
                  <li className={"file-export-row-title-"+this.state.acquirerCode}>
                    {translations.fileNameLabel}:
                  </li>
                  <li>
                    <div className={"file-export-row-item "+this.state.acquirerCode+ "field"}>
                      <input
                        id={`${
                          this.props.suggestedFileName
                          }_export_fileName_textbox`}
                        className="field-input"
                        type="text"
                        name="fileName"
                        onChange={(event) => this.onFileNameChange(event)}
                        value={this.state.fileName}
                      />
                    </div>
                  </li>
                </ul>
                {!!this.state.warning && (
                  <div className="file-export-row">
                    <span className="danger-text">{this.state.warning}</span>
                  </div>
                )}
                <div className="file-export-footer">
                  <Button
                    id={`${this.props.suggestedFileName}_export_btn_cancel`}
                    category="small link"
                    action={this.cancelAction}
                    extraClass="cancel"
                  >
                    {translations.cancel}
                  </Button>
                  <SmallButton 
                    id={`${this.props.suggestedFileName}_export_btn_export`}
                    extraClass="final-export-button"
                   // extraClass="test-button"
                    action={this.exportAction}
                    disabled={disabledButton}
                  >
                    {translations.export}
                  </SmallButton>
                </div>
              </div>
            ) : (
                <div className="file-export-content empty-saved-filters">
                  <div className="question-icon" />
                  <div className="title">
                    {translations.emptySavedFilter.title}
                  </div>
                  <div className="sub-title">
                    {translations.emptySavedFilter.subTitle}
                  </div>
                  <SmallButton action={viewReport}>
                    {translations.viewReport}
                  </SmallButton>
                </div>
              )}
          </div>
        ) : (
            <div className="file-export-content">
              <span className={"file-export-header -"+this.state.acquirerCode}>
                {translations.header}
              </span>
              <ul className="file-export-row file-types">
                <li className={"file-export-row-title-"+this.state.acquirerCode}>
                  {translations.fileTypesTitle}
                </li>
                <li>
                  <ul className="file-export-row-items">{this.fileTypes}</ul>
                </li>
              </ul>
              <ul className="file-export-row export-types">
                <li className={"file-export-row-title-"+this.state.acquirerCode}>
                  {translations.exportTypesTitle}
                </li>
                <li>
                  <ul className="file-export-row-items">{this.exportTypes}</ul>
                </li>
                {!!this.state.warning && (<li>
                  <ul className="file-export-column-validation-items ">
                    <li className="columns-validation-error">{this.state.warning}</li>
                    <li>
                      <LinkInlineButton
                        action={() => {
                          this.props.updateStateOpenColumnMangerThroughFileExport(true);
                          this.cancelAction();
                        }}
                        extraClass="open-column-manager"
                      >
                        {translations.openColumnManager}
                      </LinkInlineButton>
                    </li>
                  </ul></li>)}
                {this.props.isMaxExportLimit && (
                  <div>
                    <li key={buttonClass + fileClass} className={fileClass}>
                      <button
                        id={`${this.props.suggestedFileName}_export_btn_maxExportRecordError`}
                        name="maxExportRecordError"
                        className={buttonClass}
                      >
                        {`${this.props.translations.maxExportRecordError}`}
                      </button>
                    </li>
                  </div>)
                }
              </ul>

              {this.props.canExportWithFullPan && this.props.isVisible &&
                this.state.selectedFileType.value !== 'pdf' && (
                  <div className="rectangle_pan_check_box">
                    <div className="pad-left-check">
                      <ul className="file-export-row">
                        <li>
                          <div className="export-pan-checkbox">
                            <div className="export-pan-checkbox__name">
                              <Checkbox
                                id="include-pan-check"
                                onChange={this.includePanOnChange}
                                isChecked={this.state.isFullPanExport}
                              />
                            </div>
                            <img src={icon_full_pan} className="icon-full-pan" />
                            <span className="include-full-pan-text">{translations.includeFullPan}</span>
                            <span className=" Include-full-pan-r">{`(${translations.requiresGeneration})`}</span>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                )}


              <ul className="file-export-row">
                <li className={"file-export-row-title-"+this.state.acquirerCode}>
                  {translations.fileNameLabel}
                </li>
                <li>
                  <div className={"file-export-row-item "+this.state.acquirerCode+" field"}>
                    <input
                      id={`${
                        this.props.suggestedFileName
                        }_export_fileName_textbox`}
                      className="field-input"
                      type="text"
                      name="fileName"
                      onChange={(event) => this.onFileNameChange(event)}
                      value={this.state.fileName}
                    />
                  </div>
                </li>
              </ul>

              <OptionBoxPopupFooter
                applyDisabled={disabledButton}
                applyText={translations.exportText}
                cancelText={translations.cancelText}
                id={this.props.suggestedFileName}
                onApply={this.exportAction}
                onCancel={this.cancelAction}
                extraClass={this.state.acquirerCode}
              />
            </div>
          )
        }
      </div>
    );
  }
}

FileExport.propTypes = {
  cancelAction: PropTypes.func.isRequired,
  exportAction: PropTypes.func.isRequired,
  exportSavedFilter: PropTypes.bool,
  exportTypes: PropTypes.array.isRequired,
  fileTypes: PropTypes.array.isRequired,
  getReportUserFilters: PropTypes.func,
  reportId: PropTypes.number,
  savedFilters: PropTypes.array,
  selectedExportType: PropTypes.object,
  selectedFileType: PropTypes.object,
  selectSavedFilters: PropTypes.object,
  suggestedFileName: PropTypes.string,
  translations: PropTypes.object.isRequired,
  viewReport: PropTypes.func,
  handleToast: PropTypes.func,
  hugeExportMsg: PropTypes.bool,
  isMaxExportLimit: PropTypes.bool,
  visibleColumns: PropTypes.array,
  updateStateOpenColumnMangerThroughFileExport: PropTypes.func,
  isVisible: PropTypes.bool,
  canExportWithFullPan: PropTypes.bool,
};

FileExport.defaultProps = {
  exportSavedFilter: false,
  getReportUserFilters: null,
  reportId: 0,
  savedFilters: [],
  visibleColumns: [],
  selectedExportType: null,
  selectedFileType: null,
  isVisible: false,
  selectSavedFilters: {
    value: '',
    text: '',
    action: () => { },
  },
  suggestedFileName: '',
  viewReport: () => { },
  handleToast: () => { },
  hugeExportMsg: false,
  isMaxExportLimit: false,
  updateStateOpenColumnMangerThroughFileExport: () => { },
  canExportWithFullPan: false,
};

function parseReportSavedFilters(reportSavedFilters) {
  return reportSavedFilters.map((filter) => {
    return Object.assign(
      {},
      filter,
      {
        value: filter.id,
        text: filter.name,
      },
      {
        v1: filter.v1,
        v2: filter.v2,
        id: filter.id,
        type: filter.type,
      },
    );
  });
}

function cleanSavedFilters(filters) {
  let parsedFilters;
  try {
    parsedFilters = JSON.parse(filters);
  } catch (error) {
    parsedFilters = [];
  }

  return parsedFilters.map((item) => {
    return Object.assign(
      {},
      { v1: item.v1, v2: item.v2, id: item.id, type: item.type },
    );
  });
}

export default FileExport;